// hours are expressed in Greek office hours (GMT+2)
// month is 1-based
import messages from './messages';

// IMPORTANT: Please don't use different string formats as not all browsers
//            support all of them. The suggested format below is a safe one
// format should be MM/DD/YYYY
// format for hours should be XX:XX-YY:YY

const unavailableDatesBeforeChristmas = Array(6)
  .fill(1)
  .map((_, index) => ({
    day: `12/${18 + index}/2025`,
    message: messages.beforeXmas,
  }));

const unavailableDatesTowardsNewYears = Array(6)
  .fill(1)
  .map((_, index) => ({
    day: `12/${26 + index}/2025`,
    message: messages.beforeNewYears,
  }));

export const unavailableDates = [
  ...unavailableDatesBeforeChristmas,
  ...unavailableDatesTowardsNewYears,
  {
    day: `01/01/2026`,
    message: messages.beforeNewYears,
  },
];

export const differenceFromUTC = 2;
export const DEFAULT_HOUR = '00:00-23:59';
